/* ============================================================
   Rozsviťme Česko – mapy (SVG ČR/kraj, MapLibre + OpenFreeMap město a detail bodu) + QR sdílení.
   Data ze serveru: ROZSVITME_KRAJE, ROZSVITME_MESTA, ROZSVITME_MESTO, ROZSVIT_DETAIL
   (inc/rozsvitme/enqueue.php). Mercator výpočty musí sedět s tools/build-maps.mjs.
   ============================================================ */

/* ---- Mercator helpery pro SVG mapy ---- */
function rozsvitmeMerc(lat) { return Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360)); }
function rozsvitmeBbox(svg) {
	var b = (svg.getAttribute('data-bbox') || '').split(',').map(parseFloat);
	return b.length === 4 && !b.some(isNaN) ? { s: b[0], w: b[1], n: b[2], e: b[3] } : null;
}
/* Pozice lat/lng v procentech plochy SVG (0–100). */
function rozsvitmePos(bb, lat, lng) {
	return {
		x: (lng - bb.w) / (bb.e - bb.w) * 100,
		y: (rozsvitmeMerc(bb.n) - rozsvitmeMerc(lat)) / (rozsvitmeMerc(bb.n) - rozsvitmeMerc(bb.s)) * 100
	};
}

/* Vloží piny měst do .mapa-svg-wrap (pozice z data-bbox přes Mercator).
   Popisek jde přes textContent – titulky se nikdy nevkládají jako HTML. */
function rozsvitmePiny(wrap, mesta) {
	var svg = wrap.querySelector('svg');
	var bb = svg && rozsvitmeBbox(svg);
	if (!bb || !mesta) return;
	mesta.forEach(function (m) {
		var lat = parseFloat(m.lat), lng = parseFloat(m.lng);
		if (!lat || !lng) return;
		var p = rozsvitmePos(bb, lat, lng);
		if (p.x < 0 || p.x > 100 || p.y < 0 || p.y > 100) return;
		var a = document.createElement('a');
		a.className = 'mapa-pin';
		a.href = m.url;
		a.style.left = p.x.toFixed(2) + '%';
		a.style.top = p.y.toFixed(2) + '%';
		a.innerHTML = '<svg width="18" height="24" viewBox="0 0 30 40"><path d="M15 0C6.7 0 0 6.7 0 15c0 11 15 25 15 25s15-14 15-25C30 6.7 23.3 0 15 0z" fill="#C23A2C"/><circle cx="15" cy="14.5" r="5.5" fill="#fff"/></svg>';
		var lbl = document.createElement('span');
		lbl.className = 'pin-lbl';
		lbl.textContent = m.nazev;
		a.appendChild(lbl);
		wrap.appendChild(a);
	});
}

/* Navěsí kliky na plochy krajů (URL z ROZSVITME_KRAJE dle data-kraj).
   Hover: jméno kraje do .mapa-kraj-nazev (je-li na stránce) + zvýraznění chipu v .kraje-seznam.
   Kraj z data-kraj-aktivni wrapperu (stránka kraje / města) dostane .kraj-aktivni a není klikací. */
function rozsvitmeKrajeKliky(wrap) {
	if (typeof ROZSVITME_KRAJE === 'undefined') return;
	var nazevEl = wrap.querySelector('.mapa-kraj-nazev');
	var aktivni = wrap.getAttribute('data-kraj-aktivni') || '';
	Array.prototype.forEach.call(wrap.querySelectorAll('[data-kraj]'), function (path) {
		if (aktivni && path.getAttribute('data-kraj') === aktivni) {
			path.classList.add('kraj-aktivni');
			return;
		}
		var url = ROZSVITME_KRAJE[path.getAttribute('data-kraj')];
		if (!url) return;
		path.classList.add('aktivni');
		path.addEventListener('click', function () { window.location.href = url; });
		path.addEventListener('mouseenter', function () {
			var t = path.querySelector('title');
			var chip = document.querySelector('.kraje-seznam a[href="' + url + '"]');
			if (nazevEl && t) nazevEl.textContent = t.textContent;
			if (chip) chip.classList.add('chip-hover');
		});
		path.addEventListener('mouseleave', function () {
			var chip = document.querySelector('.kraje-seznam a[href="' + url + '"]');
			if (nazevEl) nazevEl.textContent = '';
			if (chip) chip.classList.remove('chip-hover');
		});
	});
}

/* ---- Mapa ČR (hlavní stránka): klik na kraj + piny všech měst ---- */
(function () {
	var wrap = document.getElementById('mapa-cr');
	if (!wrap) return;
	rozsvitmeKrajeKliky(wrap);
	if (typeof ROZSVITME_MESTA_CR !== 'undefined') {
		rozsvitmePiny(wrap, ROZSVITME_MESTA_CR);
	}
})();

/* ---- Mapa na kraji a městě: celá ČR, aktivní kraj zvýrazněný, ostatní kraje klikací, piny měst ---- */
(function () {
	var wrap = document.getElementById('mapa-kraj');
	if (!wrap) return;
	rozsvitmeKrajeKliky(wrap);
	if (typeof ROZSVITME_MESTA !== 'undefined') {
		rozsvitmePiny(wrap, ROZSVITME_MESTA);
	}
})();

/* ---- Sdílené pro MapLibre: pin dle barvy. Povinná attribution (OpenFreeMap © OpenMapTiles, data OSM)
   přichází ze zdroje stylu (TileJSON), proto se nepřidává ručně – byla by pod mapou dvakrát. ---- */
var RC_STYLE = 'https://tiles.openfreemap.org/styles/positron';
function rcPinEl(color) {
	var d = document.createElement('div');
	d.className = 'mapa-pin-gl';
	d.innerHTML = '<svg width="30" height="40" viewBox="0 0 30 40"><path d="M15 0C6.7 0 0 6.7 0 15c0 11 15 25 15 25s15-14 15-25C30 6.7 23.3 0 15 0z" fill="' + color + '"/><circle cx="15" cy="14.5" r="5.5" fill="#fff"/></svg>';
	return d;
}
function rcMap(id, lng, lat, zoom) {
	var map = new maplibregl.Map({ container: id, style: RC_STYLE, center: [lng, lat], zoom: zoom, scrollZoom: false, attributionControl: { compact: false } });
	map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-left');
	return map;
}

/* ---- Mapa města (MapLibre + OpenFreeMap): piny projektů dle stavu + filtry ---- */
(function () {
	var el = document.getElementById('mapa-mesto');
	if (!el || typeof maplibregl === 'undefined' || typeof ROZSVITME_MESTO === 'undefined') return;
	var DATA = ROZSVITME_MESTO.projekty || [];
	var STAVY = ROZSVITME_MESTO.stavy || {};

	// Pozor: wp_localize_script může poslat skaláry jako řetězce – parseFloat, jinak je i "0" truthy.
	var cLat = parseFloat(ROZSVITME_MESTO.lat) || 49.8;
	var cLng = parseFloat(ROZSVITME_MESTO.lng) || 15.5;
	var fallback = (cLat === 49.8 && cLng === 15.5);
	var map = rcMap('mapa-mesto', cLng, cLat, fallback ? 6 : 11);

	// Popup skládáme z DOM uzlů (název z DB nikdy přes innerHTML).
	function popupEl(v, s) {
		var box = document.createElement('div');
		var b = document.createElement('b'); b.textContent = v.nazev; box.appendChild(b);
		box.appendChild(document.createElement('br'));
		box.appendChild(document.createTextNode(s.label || ''));
		box.appendChild(document.createElement('br'));
		var a = document.createElement('a'); a.href = v.url; a.textContent = 'Zobrazit detail →'; box.appendChild(a);
		return box;
	}
	var markery = DATA.filter(function (v) { return parseFloat(v.lat) && parseFloat(v.lng); }).map(function (v) {
		var s = STAVY[v.stav] || { color: '#C23A2C', label: '' };
		var m = new maplibregl.Marker({ element: rcPinEl(s.color), anchor: 'bottom' })
			.setLngLat([parseFloat(v.lng), parseFloat(v.lat)])
			.setPopup(new maplibregl.Popup({ offset: 38 }).setDOMContent(popupEl(v, s)))
			.addTo(map);
		m._stav = v.stav;
		return m;
	});

	// Filtry dle stavu (chipy nad mapou)
	var filtry = [{ k: 'all', label: 'Vše', color: 'var(--navy)' }].concat(Object.keys(STAVY).map(function (k) { return { k: k, label: STAVY[k].kratky, color: STAVY[k].color }; }));
	var active = 'all';
	var filtryEl = document.getElementById('filtry');
	function renderFiltry() {
		if (!filtryEl) return;
		filtryEl.innerHTML = filtry.map(function (f) {
			var dot = f.k === 'all' ? '' : '<span class="dot" style="background:' + f.color + '"></span>';
			return '<button class="filter-chip' + (active === f.k ? ' active' : '') + '" data-k="' + f.k + '">' + dot + f.label + '</button>';
		}).join('');
	}
	function applyFilter() {
		markery.forEach(function (m) {
			var show = (active === 'all' || m._stav === active);
			m.getElement().style.display = show ? '' : 'none';
			if (!show && m.getPopup() && m.getPopup().isOpen()) { m.togglePopup(); }
		});
	}
	if (filtryEl) {
		filtryEl.addEventListener('click', function (e) {
			var b = e.target.closest('[data-k]');
			if (!b) return;
			active = b.getAttribute('data-k');
			renderFiltry();
			applyFilter();
		});
		renderFiltry();
	}
})();

/* ---- Partneři města: plynulý marquee (linear autoplay), pauza na hover.
   Málo partnerů (< 5) = statický pás bez ježdění (loop by neměl co točit). ---- */
(function () {
	var el = document.querySelector('.partneri-swiper');
	if (!el || typeof Swiper === 'undefined') return;
	var slides = el.querySelectorAll('.swiper-slide').length;
	var marquee = slides >= 5;
	if (marquee) {
		// Smyčka potřebuje víc slidů, než se vejde do viewportu – naklonujeme sadu.
		var wr = el.querySelector('.swiper-wrapper');
		Array.prototype.slice.call(wr.children).forEach(function (sl) { wr.appendChild(sl.cloneNode(true)); });
	}
	new Swiper(el, {
		slidesPerView: 'auto',
		spaceBetween: 24,
		loop: marquee,
		speed: marquee ? 5000 : 400,
		autoplay: marquee ? { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
		grabCursor: true
	});
})();

/* ---- Detail projektu: mapka jednoho bodu + QR sdílení ---- */
(function () {
	var box = document.getElementById('qr-bod');
	if (box && typeof qrcode === 'function') {
		var qr = qrcode(0, 'M');
		qr.addData(location.href);
		qr.make();
		box.innerHTML = qr.createImgTag(4, 0);
		var im = box.querySelector('img');
		if (im) { im.style.width = '100%'; im.style.height = 'auto'; im.style.imageRendering = 'pixelated'; }
	}
	var el = document.getElementById('mapa-detail');
	if (!el || typeof maplibregl === 'undefined' || typeof ROZSVIT_DETAIL === 'undefined' || !parseFloat(ROZSVIT_DETAIL.lat)) return;
	var d = ROZSVIT_DETAIL;
	var map = rcMap('mapa-detail', parseFloat(d.lng), parseFloat(d.lat), 15);
	new maplibregl.Marker({ element: rcPinEl(d.color), anchor: 'bottom' }).setLngLat([parseFloat(d.lng), parseFloat(d.lat)]).addTo(map);
})();
